/**
 * components/SiteBadge.js
 * A small fixed badge naming WHICH site this is — "Developer" on the staging site
 * (Cloudflare's Preview variable REACT_APP_SITE_LABEL), nothing at all on the client's site,
 * where the variable isn't set. So nobody ever mistakes the developers' test books for the
 * client's real ones. Never printed: it renders inside #root, which printFoundation.css hides
 * when a document prints (the printed documents portal to document.body instead).
 */
import React from "react";

export default function SiteBadge({ label }) {
  const text = (label || "").trim();
  if (!text) return null;
  return <div className="site-badge" role="note" title="Situs ini bukan situs klien">{text}</div>;
}
